import { createAction, props } from '@ngrx/store';

import { ScannedCode, ScannedCodeWithEntity } from 'app/features/scan-flow/models';
import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { RowSelectionItem } from 'app/shared/features/map-row-selector/models';

import { ScanFlowRegistrationData } from './scan-flow.reducer';

// -- Scan Flow Step --
export const initScanFlow = createAction('[ScanFlow] Initialize');

export const initScanFlowSuccess = createAction('[ScanFlow] Initialization Success');

export const startScanCode = createAction('[ScanFlow] Start scan code for flow');

export const syncScannedCodeFromStore = createAction(
    '[ScanFlow] Sync Code From Store',
    props<{ token: string }>(),
);

export const showNotificationScanFlowInProgressRegistrationDataSent = createAction(
    '[ScanFlow] Show Notification In-progress Registration Data Sent',
);

export const userInputForScanFlowStarted = createAction('[ScanFlow] User Input Started');

export const userInputForScanFlowEnded = createAction('[ScanFlow] User Input Ended');

// -- Scan Flow Set Registration --
export const setScanFlowEmployeeNumber = createAction(
    '[ScanFlow] Set Employee Number',
    props<{ employeeNumber: number | undefined }>(),
);

export const setActivityInScanFlow = createAction(
    '[ScanFlow] Set Activity In Flow',
    props<{
        activityCode: ScannedCodeWithEntity<Activity> | undefined;
        keepRegistrationData: boolean;
        isContainerMeasurement?: boolean;
        batchCode?: ScannedCode;
    }>(),
);

export const setBatchInScanFlow = createAction(
    '[ScanFlow] Set Batch In Flow',
    props<{
        batchCode: ScannedCode;
        keepRegistrationData: boolean;
        isContainerMeasurement?: boolean;
    }>(),
);

export const changeScanFlowRowSelection = createAction(
    '[ScanFlow] Change Row Selection',
    props<RowSelectionItem>(),
);

export const setScanFlowAmountResult = createAction(
    '[ScanFlow] Set Amount Result',
    props<{ amountResult: number | undefined }>(),
);

export const setScanFlowProductBoxRegistrations = createAction(
    '[ScanFlow] Set Product Box Registrations',
    props<{ updatedProductBoxRegistrations: ProductBoxRegistration[] }>(),
);

// -- Manage Registration Data in Cache & Local Storage Actions --
export const applyScanFlowRegistrationDataFromStorage = createAction(
    '[ScanFlow] Apply Registration Data From Storage',
    props<{
        registrationDataFromStorage: ScanFlowRegistrationData | undefined;
    }>(),
);

export const updateScanFlowRegistrationDataInStorage = createAction(
    '[ScanFlow] Update Scan Flow Registration Data In Storage',
    props<ScanFlowRegistrationData>(),
);

export const resetScanFlowRegistrationData = createAction('[ScanFlow] Set Registration Data');

export const resetPartialScanFlowRegistrationData = createAction('[ScanFlow] Set Partial Registration Data');
